import React, { FC } from "react";
import TypeIcon from "../../../../../../images/common/product.svg";
import {
  CustomLabel,
  FlexContainer,
  ToggleSwitch,
  UtilityMethods,
} from "@mindmemobile/mm-shared-global";
import { ItemDetailPageModel } from "../../../shared/models";
import { DescriptionCell, LabelCell } from "../../../shared/styles";

type IProps = {
  item: ItemDetailPageModel;
  type: string;
  onStatusChange: (status: boolean) => void;
};

const ItemSection: FC<IProps> = ({ item, type, onStatusChange }) => {
  const row = (
    label: string,
    rightColumn: string | React.ReactNode
  ): React.ReactNode => {
    return (
      <FlexContainer className="label-description-row">
        <LabelCell>
          <CustomLabel>{label}</CustomLabel>
        </LabelCell>
        <DescriptionCell>{rightColumn}</DescriptionCell>
      </FlexContainer>
    );
  };
  return (
    <>
      {row(
        "Status",
        <ToggleSwitch
          on={item.isActive}
          onChange={() => onStatusChange(!item.isActive)}
        />
      )}
      {row(
        "Type",
        <FlexContainer>
          <img src={TypeIcon} className="type-icon" />
          <CustomLabel>{type}</CustomLabel>
        </FlexContainer>
      )}
      {row("Name", <CustomLabel>{item.name}</CustomLabel>)}
      {row(
        "Description",
        <CustomLabel className="description-label">
          {" "}
          {item.description || "-"}
        </CustomLabel>
      )}
      {row("Category", <CustomLabel>{item.category?.name || "-"}</CustomLabel>)}
      {row("Item ID", <CustomLabel> {item.id}</CustomLabel>)}
      {row("SKU", <CustomLabel> {item.sku || "-"}</CustomLabel>)}
      {row("Barcode", <CustomLabel> {item.barCode || "-"}</CustomLabel>)}
      {row(
        "Created Date",
        <CustomLabel>
          <>
            {(item.createdDate &&
              UtilityMethods.formatDateInStringWithTime(item.createdDate)) ||
              "-"}
          </>
        </CustomLabel>
      )}
    </>
  );
};
export default ItemSection;
